import React, { Fragment } from 'react'
import Helmet from 'react-helmet'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import slugify from 'react-slugify'

import StoreGroup from './StoreGroup'
import StorePage from './StorePage'

import yn from 'yn'

const capitalize = require('capitalize')

const StoreVoucher = ({ stores }) => {
  let virtualVouchers = []
  let physicalVouchers = []

  const removeVouchersIds = process.env.REACT_APP_REMOVE_VOUCHERS ? process.env.REACT_APP_REMOVE_VOUCHERS.split(',') : []
  const addVirtual = process.env.REACT_APP_ADD_VIRTUAL_VOUCHERS ? process.env.REACT_APP_ADD_VIRTUAL_VOUCHERS.split(',') : []
  const addPhysical = process.env.REACT_APP_ADD_PHYSICAL_VOUCHERS ? process.env.REACT_APP_ADD_PHYSICAL_VOUCHERS.split(',') : []

  if (stores.vouchers && stores.vouchers.length) {
    stores.vouchers.map((store) => {
      var storeNameSlug = slugify(store.description, { delimiter: '-' })

      if (!removeVouchersIds.includes(store.supplierId)) {
        if (yn(process.env.REACT_APP_VIRTUAL_VOUCHERS_ENABLED) && (storeNameSlug.includes('virtual') || addVirtual.includes(`${store.supplierId}`))) {
          virtualVouchers.push({ ...store, name: sanitizeString(store.name, 'virtual') })
        } else if (yn(process.env.REACT_APP_PHYSICAL_VOUCHERS_ENABLED) && (storeNameSlug.includes('fisico') || addPhysical.includes(`${store.supplierId}`))) {
          physicalVouchers.push({ ...store, name: sanitizeString(store.name, 'fisico') })
        }
      }
    })

    virtualVouchers = virtualVouchers.sort(sortString)
    physicalVouchers = physicalVouchers.sort(sortString)
  }

  return (
    <Fragment>
      <Helmet>
        <title>{`Todos os cupons e serviços - ${process.env.REACT_APP_TITLE || ''}`}</title>
      </Helmet>
      {
        yn(process.env.REACT_APP_PHYSICAL_VOUCHERS_ENABLED) &&
        <StorePage>
          <div className='row'>
            <StoreGroup
              items={physicalVouchers}
              title={process.env.REACT_APP_PHYSICAL_VOUCHERS_TITLE || 'Vouchers Físicos'}
              hasContent={physicalVouchers.length > 0}
            />
          </div>
        </StorePage>
      }
      {
        yn(process.env.REACT_APP_VIRTUAL_VOUCHERS_ENABLED) &&
        <StorePage>
          <div className='row'>
            <StoreGroup
              items={virtualVouchers}
              title={process.env.REACT_APP_VIRTUAL_VOUCHERS_TITLE || 'Vouchers Virtuais'}
              hasContent={virtualVouchers.length > 0}
            />
          </div>
        </StorePage>
      }
    </Fragment>
  )
}

StoreVoucher.propTypes = {
  stores: PropTypes.object.isRequired
}

const sortString = (a, b) => {
  var aName = slugify(a.name, { delimiter: '-' })
  var bName = slugify(b.name, { delimiter: '-' })

  if (aName > bName) {
    return 1
  } else if (bName > aName) {
    return -1
  }
  return 0
}

const sanitizeString = (string, type) => {
  var str = string.toLowerCase().replace(type, '')

  if (type === 'fisico') {
    str = str.replace('físico', '')
  }

  str = str.trim().replace(' -', '').replace('-', '').replace('.', '').replace('dshop', '')
  str = str.trim().replace('-', '').trim()
  str = str.trim().replace('b2w ', '').trim()
  str = str.trim().replace('pg', '').trim()
  str = str.trim().replace('americanascom', 'americanas.com').trim()
  return capitalize.words(str)
}

const mapStateToProps = ({ stores }) => ({
  stores
})

export default connect(
  mapStateToProps,
  null
)(StoreVoucher)



// WEBPACK FOOTER //
// ./src/features/Store/StoreVoucher.js